import {notification} from "antd";

export const copy = (link: string) => navigator.clipboard.writeText(link)

export const handleCopy = (link: string) => {
    copy(link).then(() => {
        notification.open({
            message: 'Ссылка скопирована успешно!',
            duration: 3.5,
        })
    })
}
